import React, { useEffect, useRef, useState } from "react";

const Dashboardlock = () => {
  const sectionRef = useRef(null);
  const [lockVisible, setLockVisible] = useState(false);

  useEffect(() => {
    const sectionEl = sectionRef.current;
    if (!sectionEl) return;

    const hasIntersectionObserver =
      typeof window !== "undefined" && "IntersectionObserver" in window;

    if (!hasIntersectionObserver) {
      setLockVisible(true);
      return;
    }

    const updateLockVisibility = (visible) => {
      setLockVisible((prev) => (prev === visible ? prev : visible));
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio >= 0.25) {
          updateLockVisibility(true);
        } else if (entry.intersectionRatio === 0) {
          updateLockVisibility(false);
        }
      },
      { threshold: [0, 0.25] }
    );

    observer.observe(sectionEl);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative w-full overflow-hidden bg-black text-white"
    >
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-8 px-6 py-10 sm:py-12 md:gap-10 md:px-10 lg:flex-row lg:px-12 lg:py-14">
        {/* LEFT SIDE CONTENT */}
        <div className="z-10 w-full text-center lg:w-1/2 lg:text-left">
          <span className="mb-5 inline-flex items-center justify-center rounded-md border border-[#A855F7] px-4 py-2 text-xs text-[#A855F7] sm:px-6 sm:text-sm md:text-base">
            About us
          </span>

          <h2 className="text-3xl font-semibold leading-tight sm:text-4xl lg:text-5xl lg:leading-[1.05]">
           Building a Marketplace for Local Communities
          </h2>

       <p className="mt-5 text-sm text-gray-300 sm:text-base lg:max-w-xl">
  Our vision is to create a vibrant marketplace that empowers local entrepreneurs, small restaurants, farmer markets, and business-minded individuals who need funding but lack access to resources. <br /><br/>
  By joining our community and sharing our mission, we aim to connect hardworking local business owners with the people in their neighborhoods  fostering growth, collaboration, and sustainable development. Together, we can strengthen our communities, one neighborhood at a time.
</p>

        </div>

        {/* RIGHT SIDE IMAGES */}
        <div className="relative flex w-full justify-center lg:w-1/2">
          {/* Lock background circle */}
          <img
            src="/images/shield.png"
            alt="Lock Background"
            className="w-full max-w-[280px] sm:max-w-[340px] md:max-w-[420px] lg:max-w-[520px] xl:max-w-[600px] opacity-90"
          />

          {/* Floating lock & label */}
          <div className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center gap-4 transform -translate-y-3 sm:-translate-y-4 md:-translate-y-5">
            <img
              src="/images/synergy.png"
              alt="Lock"
              className={`w-[100px] sm:w-[130px] md:w-[170px] lg:w-[200px] xl:w-[220px] ${
                lockVisible
                  ? "lock-pop-spin drop-shadow-[0_18px_38px_rgba(168,85,247,0.35)]"
                  : "opacity-0"
              }`}
            />
          <span
  className={`text-xl font-extrabold italic tracking-[0.3em] text-[#A855F7] sm:text-4xl ${
    lockVisible ? "lock-pop-only" : "opacity-0"
  }`}
>
  SCI
</span>

          </div>
        </div>
      </div>

      {/* LEFT corner background image */}
      <img
        src="/images/new.png"
        alt="Left Decoration"
        className="absolute left-0 top-0 hidden w-[80px] opacity-80 sm:block"
      />
    </section>
  );
};

export default Dashboardlock;
